import React from 'react';
import Reflux from 'reflux';
import EventObjectSearchStore from 'flux/stores/EventObjectSearchStore';
import EventObjectSearchActions from 'flux/actions/EventObjectSearchActions';
import EventFolderListActions from 'flux/actions/EventFolderListActions';
import RouteActions from 'flux/actions/RouteActions';
import { Input, Overlay } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import FSObjectIcon from 'shared/components/event/fsObjectIcon';
import truncate from 'underscore.string/truncate';
import classNames from 'classnames';
import Breadcrumb from 'shared/components/misc/breadcrumb';

import keyBinder from 'shared/lib/keyBinder';

const ListKeyScope = 'fsObjectList';
const SearchKeyScope = ListKeyScope + '_search';

import {
  getFSObjectClickHandler,
  isDocFSObject,
} from 'shared/components/event/fsObjectUtils';

export default React.createClass({
  mixins: [Reflux.connect(EventObjectSearchStore, 'search')],

  render() {
    return (
      <div className="event-folder-search-wrap">
        <Input
          placeholder="Search this event"
          type="text"
          autoFocus
          className="event-folder-search-input"
          ref={(c) => {
            if (!c) return;
            this._searchInput = c;
          }}
          addonAfter={this._getSearchAddonNode()}
          onBlur={() => {
            if (this.state.search.get('results')) return;
            EventObjectSearchActions.toggleVisibility();
          }}
          onChange={this._handleTermChange}
        />
        {this._getSearchResultsNode()}
      </div>
    );
  },

  _getSearchAddonNode() {
    let enabled = this.state.search.get('enabled');
    let onClick = this._focusInput;
    let iconName = 'search';

    if (enabled) {
      iconName = 'times-circle';
      onClick = EventObjectSearchActions.toggleVisibility;
    }

    return (
      <span className="search-prefix-wrapper" onClick={onClick}>
        <Icon name={iconName} />
      </span>
    );
  },

  _getSearchResultsNode() {
    let { teamId, eventId } = this.props;

    let state = this.state.search;

    let results = state.get('results'),
      term = state.get('term');

    if (!results) return null;

    let contentNode = this._getNoResultsNode();
    if (results.size) {
      contentNode = results.map((result) => (
        <ResultItem
          term={term}
          result={result}
          teamId={teamId}
          eventId={eventId}
        />
      ));
    }

    return (
      <Overlay
        show={true}
        placement="bottom"
        onHide={() => {
          if (this._searchInput.refs.input === document.activeElement) return;
          EventObjectSearchActions.toggleVisibility();
        }}
        container={this}
        rootClose
      >
        <div className="event-folder-search-results">{contentNode}</div>
      </Overlay>
    );
  },

  _getNoResultsNode() {
    return <span>There are no results..</span>;
  },

  _focusInput() {
    this._searchInput.refs.input.focus();
  },

  _handleTermChange(e) {
    EventObjectSearchActions.setTerm(e.target.value);
  },

  _handleEscapeKeyPress(e) {
    e.preventDefault();
    EventObjectSearchActions.toggleVisibility();
  },

  _bindHotKeys() {
    keyBinder.setScope(SearchKeyScope);

    _bindings.forEach((binding) => {
      let [key, handler] = binding;
      keyBinder.assign(key, SearchKeyScope, this[handler]);
    });
  },

  componentDidMount() {
    this._bindHotKeys();
  },

  componentWillUnmount() {
    this._unbindHotKeys();
  },

  _unbindHotKeys() {
    _bindings.forEach((binding) => {
      let [key, handler] = binding;
      keyBinder.unbind(key, SearchKeyScope, this[handler]);
    });

    keyBinder.setScope(ListKeyScope);
  },

  _handleUpKeyPress() {
    EventObjectSearchActions.moveSelectionUp();
  },

  _handleDownKeyPress() {
    EventObjectSearchActions.moveSelectionDown();
  },

  _handleEnterKeyPress() {
    let { teamId, eventId } = this.props;

    let selected = this.state.search
      .get('results')
      .find((res) => res.get('selected'));

    if (selected) {
      getFSObjectClickHandler(selected, teamId, eventId)();
      EventObjectSearchActions.toggleVisibility();
    }
  },
});

const _bindings = [
  ['esc', '_handleEscapeKeyPress'],
  ['up', '_handleUpKeyPress'],
  ['down', '_handleDownKeyPress'],
  ['enter', '_handleEnterKeyPress'],
];

/* eslint-disable react/prop-types */
const ResultItem = ({ result, term, teamId, eventId }) => {
  let clickHandler = getFSObjectClickHandler(result, teamId, eventId);

  let classes = classNames(
    'event-folder-search-result-item clearfix',
    {
      selected: result.get('selected'),
    },
    'pointer',
  );

  let truncated = truncate(result.get('name'), 40),
    termFoundIndex = truncated.toLowerCase().indexOf(term.toLowerCase());

  if (termFoundIndex !== -1) {
    let re = new RegExp(term, 'i');
    let match = re.exec(truncated);
    truncated = truncated.replace(match[0], '');
    var p1 = truncated.slice(0, match.index);
    var p2 = truncated.slice(match.index);
    truncated = (
      <span>
        {p1}
        <strong>{match[0]}</strong>
        {p2}
      </span>
    );
  }

  return (
    <div
      onClick={() => {
        clickHandler();
        if (!isDocFSObject(result)) EventObjectSearchActions.toggleVisibility();
      }}
      className={classes}
    >
      <div>
        <FSObjectIcon item={result} />
        {truncated}
      </div>
      <div
        className="event-folder-search-result-description pointer"
        onClick={(e) => {
          EventObjectSearchActions.toggleVisibility();
          e.stopPropagation();
          if (!result.get('parentId')) {
            RouteActions.goToEvent({ teamId, eventId });
          } else {
            let parts = result.get('parentPath').split(',');
            let name = parts.pop();

            EventFolderListActions.setFolderPath(parts.join(','), name);
          }
        }}
      >
        in <Breadcrumb path={result.get('parentPath')} inline />
      </div>
    </div>
  );
};
/* eslint-enable react/prop-types */
